import { useSearchParams } from 'react-router-dom';

import { SatCreditsOnetimeTransaction } from '@/components/transactions/SatCreditsOnetimeTransaction';
import { isFiniteNumber } from '@/utils';

const CREDITS_QTY_PARAM = 'credits';

export const SatCreditsAddOnetimePage = () => {
    const [searchParams] = useSearchParams();
    const creditsQty = parseInt(searchParams.get(CREDITS_QTY_PARAM) ?? '');
    return <SatCreditsOnetimeTransaction initialQuantity={isFiniteNumber(creditsQty) ? creditsQty : undefined} />;
};
